// ТАБИ
document.querySelectorAll('.container').forEach(container => {
  const tabs = container.querySelectorAll('.tab');
  const contents = container.querySelectorAll('.tab-content[data-content]');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabId = tab.dataset.tab;

      // active з табів
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // active з контенту (тільки з data-content)
      contents.forEach(content => {
        content.classList.toggle(
          'active',
          content.dataset.content === tabId
        );
      });
    });
  });
});


// Плавне з'явлення
const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target); // анімація 1 раз
    }
  });
}, {
  threshold: 0.2
});
document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

// Паралакс зображень (тільки автоматичний рух)
(() => {
  const IDLE_RADIUS_MIN = 4;
  const IDLE_RADIUS_MAX = 4;

  const items = [];

  function isInViewport(el) {
    const r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < innerHeight &&
           r.right > 0 && r.left < innerWidth;
  }

  function getAnimationType(el) {
    if (el.classList.contains('parallax-circle')) return 'circle'; 
    if (el.classList.contains('parallax-float')) return 'float';
    return 'eight'; // default
  }

  document.querySelectorAll('.parallax-item').forEach(el => {
    const radius = IDLE_RADIUS_MIN + Math.random() * (IDLE_RADIUS_MAX - IDLE_RADIUS_MIN);

    items.push({
      el,
      type: getAnimationType(el),

      x: 0,
      y: 0,
      targetX: 0,
      targetY: 0,

      speed: 0.035 + Math.random() * 0.05,

      idleRadius: radius,
      idleSpeed: 0.0004 + Math.random() * 0.001,
      idlePhase: Math.random() * Math.PI * 2,

      // для float
      floatAngle: Math.random() * Math.PI * 2,
      floatSpeed: 0.0006 + Math.random() * 0.0008
    });
  });

  function animate(time) {
    items.forEach(item => {
      if (!isInViewport(item.el)) return;

      const t = time * item.idleSpeed + item.idlePhase;

      switch (item.type) {

        // ∞ вісімка (default)
        case 'eight':
          item.targetX = Math.sin(t) * item.idleRadius;
          item.targetY = Math.sin(t * 2) * item.idleRadius * 0.6;
          break;

        // ⭕ коло
        case 'circle':
          item.targetX = Math.cos(t) * item.idleRadius;
          item.targetY = Math.sin(t) * item.idleRadius;
          break;

        // 🌊 хаотичне плавання
        case 'float':
          item.floatAngle += item.floatSpeed;
          item.targetX = Math.cos(item.floatAngle) * item.idleRadius;
          item.targetY = Math.sin(item.floatAngle * 0.7) * item.idleRadius;
          break;
      }

      item.x += (item.targetX - item.x) * item.speed;
      item.y += (item.targetY - item.y) * item.speed;

      item.el.style.transform = `translate(${item.x}px, ${item.y}px)`;
    });

    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
})();



